import { types } from "mobx-state-tree";

const Office = types.model({
  id: types.maybe(types.number),
  name: types.maybe(types.string)
});

export default Office;